import { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import PromotionLabel from '../helpers/PromotionLabel'
import PriceConverter from '../helpers/PriceConverter'
import { showItineraryPopup, setItineraryData } from '../../actions/main-actions'
import { parseQuery } from '../../utils'
import { createUrl } from '../../localized-urls'
import BookingEnquirePopup from '../popups/BookingEnquirePopup'

class PricingRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      groupBooking: {},
    }
  }

  showItinerary = (trip, isGroupTrip) => {
    this.props.setItineraryData({
      isCharter: isGroupTrip || trip.isCharter,
      itinerarySlug: trip.itinerary.slug,
      tripId: trip.id,
      dateFrom: trip.startDate,
      duration: trip.duration,
      promotion: trip.promotion,
      price: trip.price,
      compareAtPrice: trip.compareAtPrice,
      currency: this.props.currency,
      shopSlug: this.props.shopSlug,
      countrySlug: this.props.countrySlug,
      elementToScroll: trip.elementToScroll,
      insurance: this.props.insurance,
      updateUrl: !isGroupTrip,
      isGroupTrip,
    })
    this.props.showItineraryPopup(true)
  }

  generateSearchLink = (departureDate) => {
    if(departureDate && departureDate !== '') {
      return createUrl('search_la', { slug: this.props.countrySlug }, `?view=dates&departure_date=${moment(departureDate).locale('en').format('MMM-YYYY')}`)
    }
    return createUrl('search_la', { slug: this.props.countrySlug })
  }

  triggerPopup = (id, value) => {
    this.setState({
      groupBooking: {
        [id]: value,
      },
    })
  }

  render() {
    const { product, isGroupTrip, totalGuests } = this.props
    const queryParams = parseQuery() || {}
    const noSpacesForSelectedGuests = product.availability && totalGuests > product.availability
    return (
      <div className={`tr ${product.iterator % 2 === 0 ? 'even' : ''} 
        ${!product.availability || noSpacesForSelectedGuests ? 'sold_out' : ''} 
        ${isGroupTrip ? 'group-trip' : ''}
        ${+queryParams.trip_id === product.id ? 'featured' : ''}`
      } >
        <div className='td td-date content-center'>
          <span className='trip-date'>{ moment(product.startDate).utc().format('D') }</span>
          <span className='trip-month'>{ moment(product.startDate).utc().format('MMM')}</span>
        </div>
        <div className='td td-itinerary-information'>
          <div className='td-itinerary content-left'>
            <div itemProp='name'
              onClick={() => this.showItinerary(product, isGroupTrip)}
              className='name'>{ product.itinerary.title }</div>
            {
              product.title !== product.itinerary.title
                ? (<span className='itinerary-name'>{ product.title }</span>)
                : ''
            }
            <div className='detail-links'>
              <a onClick={() => this.showItinerary(product, isGroupTrip)}>
                <FormattedMessage id='itinerary_details' defaultMessage='Itinerary details' />
              </a>
              <a onClick={() => this.showItinerary({ ...product, elementToScroll: '#logistics' }, isGroupTrip)} >
                <FormattedMessage id='how_to_get_there' defaultMessage='How to get there' />
              </a>
              { !isGroupTrip && (
                <a onClick={() => this.showItinerary({ ...product, elementToScroll: '#included-section' }, isGroupTrip)} >
                  <FormattedMessage id='whats_included' defaultMessage="What's included" />
                </a>) }
            </div>
          </div>
          <div className='td-duration'>
            {
              product.duration ? (<div className='period'>
                <FormattedMessage id='duration_period'
                  defaultMessage='{ nights } nights/{ days } days'
                  values={
                    {
                      nights: product.duration,
                      days: product.duration + 1,
                    }
                  }
                />
              </div>) : '' }
            <div className='number-of-dives'>
              {
                product.itinerary.totalNumberOfDivesMax ? (
                  <FormattedMessage
                    id='dives_min_max'
                    defaultMessage='{ divesMin } - { divesMax } dives'
                    values={
                      {
                        divesMin: product.itinerary.totalNumberOfDives,
                        divesMax: product.itinerary.totalNumberOfDivesMax,
                      }
                    }
                  />
                ) : (
                  <FormattedMessage
                    id='dives_min'
                    defaultMessage='{ divesMin } dives'
                    values={
                      {
                        divesMin: product.itinerary.totalNumberOfDives,
                      }
                    }
                  />
                )
              }
            </div>
          </div>
        </div>
        { isGroupTrip ? '' : (
          <Fragment>
            <div className='td td-price content-right'>
              {
                product.isCharter
                  ? (<div className='charter-only'><FormattedMessage id='charter_only' defaultMessage='Charter only' /></div>)
                  : (
                    <div className='price'>
                      <PromotionLabel currency={this.props.currency} promotion={product.promotion} price={product.price} compareAtPrice={product.compareAtPrice} />
                      <div className='standart-price'>
                        <span className='from'>
                          <FormattedMessage id='from' defaultMessage='From' />
                        </span>
                        <i itemProp='price' content={product.price}>
                          <PriceConverter amount={product.price} currency={this.props.currency} />
                          <link itemProp='priceCurrency' content={this.props.currency} />
                        </i>
                        <small className='price-tip'><FormattedMessage id='per_trip' defaultMessage='per trip' /></small>
                      </div>
                      { product.compareAtPrice > product.price && product.availability > 0 && product.promotion && product.promotion.kind !== 30 && product.promotion.kind !== 40 ? (
                        <div className='price-information'>
                          <span className='old-price'>
                            <PriceConverter amount={product.filteredDiscount || product.compareAtPrice} currency={this.props.currency} />
                          </span>
                          <i className='font-icons info-icon'
                            onClick={() => this.showItinerary({ ...product, elementToScroll: '#deal-section' })} />
                        </div>
                      ) : '' }
                      { product.promotion && product.availability > 0 && product.promotion.kind > 20
                        ? (<div className='price-information'>
                          <span className='discount-title'>{product.promotion.title} &nbsp;<i className='font-icons info-icon'
                            onClick={() => this.showItinerary({ ...product, elementToScroll: '#deal-section' })}
                          /></span>
                        </div>) : ''
                      }
                    </div>)
              }
            </div>
            <div className={`td td-actions text-center${product.availability === 0 || noSpacesForSelectedGuests ? ' no-availability' : ''}`}>
              <div className='mobile-action-button'>
                <a onClick={() => this.showItinerary(product)}>
                  <FormattedMessage id='itinerary' defaultMessage='Itinerary' />
                </a>
              </div>
              { !product.isCharter || !product.availability
                ? (
                  <div className='product-status-wrapper'>
                    { product.availability > 0 ? (
                      <a href={createUrl('checkout_la', { slug: this.props.shopSlug, location: this.props.countrySlug }, `?productId=${product.id}`)}
                        className='btn-red'
                      ><FormattedMessage id='select_cabin' defaultMessage='Select cabin' />
                        <link itemProp='availability' href='http://schema.org/InStock' />
                      </a>
                    ) : '' }
                    <div className='product-status'>
                      { product.availability === 0
                        ? (<Fragment>
                          <p className='text-center'>
                            <span className='sold-out red'>
                              <i className='font-icons fail-icon-new' />&nbsp;<FormattedMessage id='sold_out' defaultMessage='Sold out' />
                              <link itemProp='availability' href='http://schema.org/OutOfStock' />
                              <link itemProp='price' content={product.price} />
                              <link itemProp='priceCurrency' content={this.props.currency} />
                            </span>
                          </p>
                          <a target='_blank' href={this.generateSearchLink(product.startDate)} className='alt-link'>
                            <FormattedMessage id='other_boats' defaultMessage='Other boats on this date' />
                          </a>
                        </Fragment>) : ''
                      }
                      { !noSpacesForSelectedGuests && (!product.promotion || (product.promotion && product.promotionEndIn > 0 && product.promotionEndIn > 14)) ? (
                        <span>
                          {
                            product.availability <= 4 && product.availability > 0
                              ? (<span className='red'><FormattedMessage id='spots_left' values={{
                                qty: product.availability,
                              }} defaultMessage='Only { qty, plural, one {# spot } other {# spots } } left' /></span>)
                              : ''
                          }
                          {
                            product.availability > 4 ? (
                              <span className='color-green'>
                                <i className='font-icons ok-icon-new' />&nbsp;<FormattedMessage id='available' defaultMessage='Available' />
                              </span>
                            ) : ''
                          }
                        </span>
                      ) : ''}
                      {
                        noSpacesForSelectedGuests
                          ? (<span className='red'>
                            <FormattedMessage id='no_availability_for_your_number' defaultMessage='No availability for your # of guests' />
                          </span>)
                          : ''
                      }
                      {
                        product.promotion && product.promotionEndIn > 0 && product.promotionEndIn <= 14 && product.availability > 0
                          ? (<span className='red'><FormattedMessage id='deal_expires_in' values={{
                            qty: product.promotionEndIn,
                          }} defaultMessage='Deal expires in { qty, plural, one {# day } other {# days } }' /></span>)
                          : ''
                      }
                      {
                        product.promotion && product.promotionEndIn === 0 && product.availability > 0
                          ? (<span className='red'><FormattedMessage id='deal_expires_today' defaultMessage='Deal expires today' /></span>)
                          : ''
                      }
                    </div>
                  </div>
                ) : ''
              }
              { product.isCharter && product.availability ? (
                <div className='product-status-wrapper'>
                  <button className='btn-red' onClick={() => this.triggerPopup(product.id, true)}>
                    <FormattedMessage id='contact_us' defaultMessage='Contact us' />
                    <link itemProp='availability' href='http://schema.org/InStock' />
                    <link itemProp='price' content={product.price} />
                    <link itemProp='priceCurrency' content={this.props.currency} />
                  </button>
                  <BookingEnquirePopup
                    closeModal={() => this.triggerPopup(product.id, false)}
                    isOpen={this.state.groupBooking[product.id]}
                    title={<FormattedMessage id='group_booking.title' defaultMessage='Group booking enquire' />}
                    shop={{ ...product, background: this.props.background }} />
                </div>
              ) : ''}
            </div>
          </Fragment>
        )}
      </div>)
  }
}

export default connect(
  state => ({}),
  { showItineraryPopup, setItineraryData }
)(PricingRow)
